export default __webpack_public_path__ + "static/media/galery_photo6@2x.8fa6688b.png";